export default __webpack_public_path__ + "static/472-b2528c277e5787502878d94c8558acf8.gif";